import { render, staticRenderFns } from "./UserCollect.vue?vue&type=template&id=812eae9e&scoped=true"
import script from "./UserCollect.vue?vue&type=script&lang=js"
export * from "./UserCollect.vue?vue&type=script&lang=js"
import style0 from "./UserCollect.vue?vue&type=style&index=0&id=812eae9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812eae9e",
  null
  
)

export default component.exports